import { defineComponent } from "vue";
import { u as useAccordion } from "./hooks/useAccordion-2a840d7c.mjs";
import { u as useStatefulEmits, a as useStatefulProps, b as useStateful } from "../../composables/useStateful-50e4a6b9.mjs";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
const _sfc_main = defineComponent({
  name: "VaAccordion",
  emits: [...useStatefulEmits],
  props: {
    ...useStatefulProps,
    ...useComponentPresetProp,
    modelValue: { type: Array, default: () => [] },
    multiple: { type: Boolean, default: false },
    inset: { type: Boolean, default: false },
    stateful: { type: Boolean, default: true },
    popout: { type: Boolean, default: false }
  },
  setup(props, { emit }) {
    const { valueComputed } = useStateful(props, emit, "modelValue", { defaultValue: [] });
    const { items } = useAccordion(props, valueComputed);
    return { collapses: items, value: valueComputed };
  }
});
export {
  _sfc_main as _
};

import '../../../VaAccordion.css';
//# sourceMappingURL=VaAccordion.vue_vue_type_script_lang-a8b9c6ba.mjs.map
